import { render, staticRenderFns } from "./DailyworkOfficialFeeForm.vue?vue&type=template&id=06a21fab&"
import script from "./DailyworkOfficialFeeForm.vue?vue&type=script&lang=js&"
export * from "./DailyworkOfficialFeeForm.vue?vue&type=script&lang=js&"
import style0 from "./DailyworkOfficialFeeForm.vue?vue&type=style&index=0&id=06a21fab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports